export const WEATHER_KEY = "7660438d0237b41e09bb4ea4f72bd3df";
